import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './CustomTooltip.module.scss';

interface Props {
  payload?: { payload: { Views: number } }[];
  label?: string;
}

const CustomTooltip = (props: Props): ReactElement | null => {
  if (props.payload?.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>{props.label}</p>
      <div className={styles.valueWrapper}>
        <span className={styles.bigText}>
          {props.payload?.[0].payload.Views}
        </span>
        <p className={styles.text}>
          <FormattedMessage
            id="personalInsights.chart.tooltip.views"
            defaultMessage="Views"
          />
        </p>
      </div>
      {/* <div className={styles.triangleWrapper}>
        <div className={styles.triangle}></div>
      </div> */}
    </div>
  );
};

export default CustomTooltip;
